<script setup lang="ts">
  const { width, height } = defineProps<{
    /** Ширина скелетона */
    width?: string;
    /** Высота скелетона */
    height?: string;
  }>();
</script>

<template>
  <div class="skeleton" :style="{ width, height }" />
</template>

<style scoped>
  .skeleton {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 8px;
  }

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
</style>
